import type { SessionListItem } from "../lib/api";
import { plural } from "../lib/format";
import { haptic } from "../lib/telegram";

const DATE = new Intl.DateTimeFormat("ru-RU", {
  day: "numeric",
  month: "long",
  hour: "2-digit",
  minute: "2-digit",
});

const duration = (sec: number | null) =>
  sec === null ? "идёт" : `${Math.max(1, Math.round(sec / 60))} мин`;

interface Props {
  session: SessionListItem;
  /** Подпись над карточкой, когда она стоит одна среди разделов экрана. */
  eyebrow?: string;
  onOpen: (clientId: string) => void;
}

/**
 * Карточка тренировки — одна на историю и главную.
 *
 * Раньше «Последняя тренировка» на главной была беднее той же тренировки в
 * истории: без длительности, строки упражнений и значка рекорда. Две разметки
 * одного и того же расходятся при каждой правке — теперь она одна.
 */
export default function SessionCard({ session: s, eyebrow, onOpen }: Props) {
  return (
    <button
      className="card card--tap"
      onClick={() => {
        haptic();
        onOpen(s.client_id);
      }}
    >
      {eyebrow && <span className="card__title">{eyebrow}</span>}
      <span className="hist__top">
        <span className="hist__name">{s.title}</span>
        {s.record_count > 0 && (
          <span className="hist__pr">{plural(s.record_count, "рекорд", "рекорда", "рекордов")}</span>
        )}
        {!s.finished_at && <span className="hist__live">идёт</span>}
      </span>
      <span className="hist__meta">{DATE.format(new Date(s.started_at))}</span>
      <span className="hist__stats">
        <span>{duration(s.duration_sec)}</span>
        <span>{Math.round(s.volume_kg).toLocaleString("ru-RU")} кг</span>
        <span>{plural(s.set_count, "подход", "подхода", "подходов")}</span>
      </span>
      {/* Тренировки одного дня программы называются одинаково —
          узнать нужную помогает то, что в ней делали. */}
      {s.exercises.length > 0 && (
        <span className="hist__lines">
          {s.exercises
            .slice(0, 2)
            .map((e) =>
              e.best_weight_kg === null
                ? e.name
                : `${e.name} ${Number(e.best_weight_kg.toFixed(2))}×${e.best_reps}`,
            )
            .join(" · ")}
        </span>
      )}
      {/* Отдельно от строки: при обрезке двумя строками «ещё» пропадало
          первым, и список выглядел оборванным на «·…». */}
      {s.exercises.length > 2 && (
        <span className="hist__more">
          и ещё {plural(s.exercises.length - 2, "упражнение", "упражнения", "упражнений")}
        </span>
      )}
    </button>
  );
}
